import React from 'react';
import InfoModal from '../../../../../components/data-display/InfoModal';
import Paragraph from '../../../../../components/common/Paragraph';

const DecretoModal = () => (
  <InfoModal
    buttonLabel="Sobre Decreto 418"
    title="Decreto 418"
    width={780}
    buttonProps={{ style: { marginTop: '-5px' } }}
  >
    <Paragraph align="justify">
      Corresponde a una norma elaborada por la Organización para la Cooperación y el Desarrollo
      Económico (OCDE) junto con los países del G20, la cual consiste en un sistema de intercambio
      automático de información entre los países participantes, con el fin de impedir la evasión y
      elusión fiscal en el extranjero. En Chile comenzó a regir a contar del 05 de julio de 2017 a
      través del Servicio de Impuestos Internos (Decreto N° 418).
    </Paragraph>
  </InfoModal>
);

export default DecretoModal;
